module.exports = __webpack_public_path__ + "assets/images/premium-features/shift-templates-e5d3a1.svg";